// extracted by mini-css-extract-plugin
export default {"operationStatusPresentation":"UMkRms"};